import { graphql } from 'react-relay';

export const aboManagerFragment = graphql`
    fragment AboManager_component on SubscriptionManager
    @argumentDefinitions(
        salesAdmission: { type: "String!" }
        retailOnly: { type: "Boolean!" }
    ) {
        id
        subscriptiontable(salesAdmission: $salesAdmission, retailOnly: $retailOnly) {
            id
            ...AboTable_table
        }
        priceinfo( salesAdmission: $salesAdmission ) {
            id
            checked
            ...PriceInfo_component
        }
        changesbuttontext
    }
`;
